const xendit = 'Xendit';
const deposit = 'Deposit';

export { xendit, deposit };
